// Matches hub-http-janus/loadBalancers.ts and rpc-client-utils/chirp-quick-fetch.ts
const HUBTEAM_DOMAIN = /\.hubteam(qa)?\.com$/;

export const isHubteamDomain = (
  hostname = typeof window !== 'undefined'
    ? window.location?.hostname ?? ''
    : ''
) => HUBTEAM_DOMAIN.test(hostname);
